import { SwapRightOutlined } from "@ant-design/icons";
import { Divider } from "antd";
import { datetime } from "../../../../../../util/library/datetime";
import { OPERATION_TYPE, SHORT_DATETIME_FORMAT } from "../../../../../../util/varibles/constants";
import Id from "../../../../../Operation/Id";
import Logo from '../../../../../Operation/Logo';
import OperationStatus from '../../../../../Operation/OperationStatus';
import { IPropsSearchItem } from "../constants";
import styles from "../style.module.scss";

interface IProps extends IPropsSearchItem {
}

const Service: React.FC<IProps> = (props) => {
    const {
        operation_code,
        vessel_name,
        est_start_time,
        est_finish_time,
        status,
    } = props.data;
    return <div className={styles['item-result']}>
        <div className={styles['line-info-item']}>
            <Logo type={OPERATION_TYPE.SERVICE} status={status} />
            <Id className='ml-[2px] mr-1' operation={{ operation_code }} status={status} />
        </div>
        <div className={styles['line-info-item']}>
            <div className={styles['operation-type']}>
            </div>
        </div>
        <div className={styles['line-info-item']}>
            <span>{vessel_name}</span>
            <Divider className={styles['divider-line']} orientation="vertical" />
            <OperationStatus status={status} />
        </div>
        <div className={styles['line-info-item']}>
            {datetime(est_start_time).format(SHORT_DATETIME_FORMAT)}
            <SwapRightOutlined className='ml-2 mr-2 font-s3' />
            {datetime(est_finish_time).format(SHORT_DATETIME_FORMAT)}
        </div>
    </div>;
}

export default Service;
